import { MetricSelector } from '../../MetricSelector'
import { METRIC_OPTIONS } from '../../../hooks/useProfileAnalysisFilters'
import type { RiskProfileMetricOption } from '../../../types/riskProfile.types'

interface GroupMetricControlProps {
  metricOption: RiskProfileMetricOption
  onMetricChange: (value: string) => void
}

export function GroupMetricControl({ metricOption, onMetricChange }: GroupMetricControlProps) {
  return (
    <div className="w-56">
      <MetricSelector
        value={metricOption.value}
        onValueChange={onMetricChange}
        label="Select metric"
        options={METRIC_OPTIONS}
      />
    </div>
  )
}
